// src/pages/client/Extension.jsx
import React, { useState, useEffect } from 'react';
import ClientNavbar from '../../components/client/ClientNavbar';
import Footer from '../../components/client/Footer';
import { Link } from 'react-router-dom';
import CalltoAction from '../../components/client/CalltoAction';

const Extension = () => {
  const [animationStep, setAnimationStep] = useState(0);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [sidePanelOpen, setSidePanelOpen] = useState(false);
  const [tagsAdded, setTagsAdded] = useState([]);
  const [importComplete, setImportComplete] = useState(false);

  // Animation séquentielle
  useEffect(() => {
    const timer = setInterval(() => {
      setAnimationStep((prev) => {
        if (prev >= 4) {
          // Reset de tous les états
          setButtonClicked(false);
          setSidePanelOpen(false);
          setTagsAdded([]);
          setImportComplete(false);
          return 0;
        }
        return prev + 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Gestion des animations selon l'étape
  useEffect(() => {
    switch (animationStep) {
      case 1:
        setButtonClicked(true);
        break;
      case 2:
        setSidePanelOpen(true);
        break;
      case 3:
        setTagsAdded(['React', 'Senior']);
        break;
      case 4:
        setImportComplete(true);
        break;
      default:
        break;
    }
  }, [animationStep]);

  const LinkedInExtensionIllustration = () => (
    <div className="w-full max-w-xl mx-auto">
      <svg 
        viewBox="0 0 500 300" 
        className="w-full h-auto drop-shadow-xl"
      >
        {/* LinkedIn Page - Simplified */}
        <rect width="500" height="300" rx="12" fill="#f3f2ef" />
        
        {/* LinkedIn Header */}
        <rect x="0" y="0" width="500" height="40" fill="#0a66c2" />
        <text x="20" y="27" fontSize="14" fontWeight="bold" fill="white">in</text>
        
        {/* Profile Card - Centered and Bigger */}
        <rect x="50" y="60" width="280" height="180" rx="12" fill="white" stroke="#e0e0e0" strokeWidth="2" />
        
        {/* Profile Photo - Bigger */}
        <circle cx="100" cy="110" r="20" fill="#e9ecef" stroke="#dee2e6" strokeWidth="2" />
        <circle cx="100" cy="107" r="8" fill="#6c757d" />
        <path d="M 92 118 Q 100 122 108 118" stroke="#6c757d" strokeWidth="2" fill="none" />
        
        {/* Profile Info - Simplified */}
        <text x="130" y="110" fontSize="16" fontWeight="bold" fill="#000000">Sarah Johnson</text>
        <text x="130" y="128" fontSize="12" fill="#666666">Senior Developer</text>
        <text x="130" y="144" fontSize="10" fill="#666666">Paris, France</text>
        
        {/* Skills Section */}
        <text x="60" y="170" fontSize="12" fontWeight="bold" fill="#000000">Compétences</text>
        <rect x="60" y="180" width="40" height="20" rx="10" fill="#dbeafe" />
        <text x="80" y="192" fontSize="9" fill="#2563eb" textAnchor="middle">React</text>
        <rect x="110" y="180" width="50" height="20" rx="10" fill="#dcfce7" />
        <text x="135" y="192" fontSize="9" fill="#16a34a" textAnchor="middle">Node.js</text>
        <rect x="170" y="180" width="60" height="20" rx="10" fill="#fef3c7" />
        <text x="200" y="192" fontSize="9" fill="#d97706" textAnchor="middle">TypeScript</text>
        
        

        
        {/* Side Panel - Simplified */}
        <g className={`transition-all duration-700 ${sidePanelOpen ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}`}>
          <rect x="350" y="60" width="140" height="180" rx="8" fill="white" stroke="#4f46e5" strokeWidth="3" />
          
          {/* Side Panel Header */}
          <rect x="350" y="60" width="140" height="35" fill="#4f46e5" rx="8" />
          <text x="420" y="82" fontSize="12" fontWeight="bold" fill="white" textAnchor="middle">Import</text>
          
          {/* Profile Preview in Panel */}
          <circle cx="375" cy="125" r="12" fill="#e9ecef" />
          <text x="395" y="130" fontSize="10" fill="#374151">Sarah Johnson</text>
          
          {/* Tags in Panel */}
          <text x="360" y="155" fontSize="10" fontWeight="bold" fill="#1e293b">Tags:</text>
          
          {/* Added Tags with Animation */}
          {tagsAdded.map((tag, index) => (
            <g key={tag}>
              <rect 
                x={360 + index * 45} 
                y="165" 
                width="40" 
                height="18" 
                rx="9" 
                fill="#dbeafe" 
                className="animate-fadeIn"
              />
              <text 
                x={380 + index * 45} 
                y="176" 
                fontSize="8" 
                fill="#2563eb" 
                textAnchor="middle"
              >
                {tag}
              </text>
            </g>
          ))}
          
          {/* Import Button */}
          <rect 
            x="365" 
            y="200" 
            width="110" 
            height="30" 
            rx="6" 
            fill={importComplete ? "#10b981" : "#4f46e5"}
            className={importComplete ? "animate-pulse" : ""}
          />
          <text 
            x="420" 
            y="220" 
            fontSize="11" 
            fontWeight="bold" 
            fill="white" 
            textAnchor="middle"
          >
            {importComplete ? "Importé ✓" : "Importer"}
          </text>
        </g>
        
        {/* Success Animation - Simpler */}
        {importComplete && (
          <g className="animate-fadeIn">
            <circle cx="250" cy="50" r="30" fill="#10b981" fillOpacity="0.9" />
            <text x="250" y="57" fontSize="24" fill="white" textAnchor="middle">✓</text>
          </g>
        )}
        
        
        
        {/* Arrow marker */}
        <defs>
          <marker id="arrowhead" markerWidth="10" markerHeight="7" 
                  refX="10" refY="3.5" orient="auto">
            <polygon points="0 0, 10 3.5, 0 7" fill="#4f46e5" />
          </marker>
          
          <style>
            {`
              .animate-fadeIn {
                animation: fadeIn 0.6s ease-out;
              }
              @keyframes fadeIn {
                from { opacity: 0; transform: scale(0.5); }
                to { opacity: 1; transform: scale(1); }
              }
            `}
          </style>
        </defs>
      </svg>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <ClientNavbar />
      
      {/* Section Hero avec texte à gauche et illustration à droite */}
      <div className="py-16 bg-gradient-to-r from-slate-800 to-slate-900">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Texte à gauche */}
            <div className='text-white'>
              <div className='mb-6'>
                  <h1 className="text-5xl font-bold mb-6 leading-tight">
                   Extension Chrome LinkedIn
                 </h1>
              </div>
              <div className=' mb-8 '>
                <p className="text-xl leading-relaxed">
                  Importez instantanément les profils LinkedIn dans votre CVthèque avec un simple clic. Gagnez des heures de saisie manuelle !              
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to='/contact'>
                 <button className="bg-indigo-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-indigo-700 transition">
                  Commencer gratuitement
                </button>
                </Link>
              </div>
            </div>
            
            {/* Illustration animée */}
            <div className="flex justify-center">
              <LinkedInExtensionIllustration />
            </div>
          </div>
        </div>
      </div>
      
      {/* How it Works Section */}
      <div className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-800 mb-4">
              Comment ça Fonctionne ?
            </h2>
          </div>

          <div className="grid md:grid-cols-4 gap-6 mb-16">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-blue-600">1</span>
              </div>
              <h3 className="text-xl font-semibold mb-3">Visitez LinkedIn</h3>
              <p className="text-slate-600">
                Naviguez sur le profil du candidat qui vous intéresse.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-indigo-600">2</span>
              </div>
              <h3 className="text-xl font-semibold mb-3">Cliquez sur Jobrise</h3>
              <p className="text-slate-600">
                Un clic sur l'icône Jobrise ouvre le panneau d'import.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-purple-600">3</span>
              </div>
              <h3 className="text-xl font-semibold mb-3">Ajoutez des Tags</h3>
              <p className="text-slate-600">
                Visualisez les données extraites et ajoutez des tags personnalisés.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-green-600">4</span>
              </div>
              <h3 className="text-xl font-semibold mb-3">Importez</h3>
              <p className="text-slate-600">
                Le candidat est automatiquement ajouté à votre CVthèque.
              </p>
            </div>
          </div>

          
          {/* Benefits Section */}
          <div className="p-8  rounded-2xl">
            <h3 className="text-2xl font-bold text-center mb-12  ">Avantages de l'Extension</h3>
            <div className="grid md:grid-cols-3 gap-12">
              <div className="text-center shadow-lg p-10 rounded-2xl ">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h4 className="font-semibold mb-2">Gain de Temps</h4>
                <p className="text-sm ">95% de temps en moins pour ajouter un candidat</p>
              </div>

              <div className="text-center shadow-lg p-10 rounded-2xl  ">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h4 className="font-semibold mb-2">Précision</h4>
                <p className="text-sm ">Aucune erreur de saisie manuelle</p>
              </div>

              <div className="text-center shadow-lg p-10 rounded-2xl  ">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a1.994 1.994 0 01-1.414.586H7a4 4 0 01-4-4V7a4 4 0 014-4z" />
                  </svg>
                </div>
                <h4 className="font-semibold mb-2">Tags Personnalisés</h4>
                <p className="text-sm ">Organisez vos candidats dès l'import</p>
              </div>

              
            </div>
          </div>
        </div>
      </div>

      <CalltoAction/>

      <Footer />
    </div>
  );
};

export default Extension;